import React, { useState } from 'react';
import './LegalPages.css';

function LegalPages() {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => setMenuOpen(prev => !prev);
    const closeMenu = () => setMenuOpen(false);

    return (
        <div className="legal-container">
            {/* 导航栏 - 与首页一致，支持手机端汉堡菜单 */}
            <nav className="navbar">
                <div className="navbar-logo">
                    <h2>上岸消考</h2>
                </div>
                <button
                    className={`navbar-toggle ${menuOpen ? 'open' : ''}`}
                    onClick={toggleMenu}
                    aria-label="菜单"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <div className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
                    <a href="/" onClick={closeMenu}>首页</a>
                    <a href="/#features" onClick={closeMenu}>软件特色</a>
                    <a href="/#download" onClick={closeMenu}>立即下载</a>
                </div>
            </nav>

            {/* 主要内容 */}
            <div className="legal-content">
                <div className="legal-card">
                    <h1 className="legal-title">隐私政策与用户协议</h1>
                    <p className="legal-update-date">
                        版本更新日期：2026 年 5 月 3 日<br/>
                        版本生效日期：2026 年 5 月 3 日
                    </p>

                    {/* 隐私政策部分 */}
                    <div id="privacy" className="legal-section">
                        <h2 className="legal-section-title">上岸消考 APP 隐私政策</h2>
                        
                        <h3 className="legal-sub-title">一、引言</h3>
                        <p className="legal-paragraph">
                            信标云（北京）科技有限公司（以下简称 "我们"、"信标云" 或 "公司"）深知个人信息对您的重要性，尊重并保护所有使用 "上岸消考"APP（以下简称 "本 APP" 或 "上岸消考"）用户的个人信息及隐私安全。本隐私政策旨在向您说明我们在您使用本 APP 提供的消防工程师考试培训服务时，如何收集、使用、存储、共享、转让、公开披露及保护您的个人信息，以及您享有的权利和行使方式。
                        </p>
                        <p className="legal-paragraph">
                            本政策依据《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》《信息安全技术个人信息安全规范》（GB/T 35273-2020）等相关法律法规和技术规范制定。您在下载、安装、注册、登录或使用本 APP 服务前，请务必仔细阅读并理解本隐私政策全部内容，特别是加粗或下划线标注的条款，您的使用行为将视为对本政策内容的认可和接受。
                        </p>

                        <h3 className="legal-sub-title">二、适用范围</h3>
                        <p className="legal-paragraph">
                            本隐私政策适用于您通过本 APP 使用的所有服务，包括但不限于账号注册、课程学习、题库练习、模拟考试、直播互动、资料下载、在线咨询等功能。本政策不适用于以下情况：
                        </p>
                        <ul className="legal-list">
                            <li>第三方通过本 APP 提供的服务（如支付服务、分享功能等），您应查阅第三方的隐私政策；</li>
                            <li>本 APP 中链接到的第三方网站或应用，您访问这些网站或应用时应遵守其隐私政策；</li>
                            <li>法律法规另有规定的情况。</li>
                        </ul>

                        <h3 className="legal-sub-title">三、我们收集的信息</h3>
                        
                        <h4 className="legal-mini-title">（一）您主动提供的信息</h4>
                        <ul className="legal-list">
                            <li>账号注册信息：手机号码、验证码、设置的密码等</li>
                            <li>个人资料信息：姓名、性别、年龄、邮箱、职业、所在地区、学历、消防相关工作经验等</li>
                            <li>学习相关信息：学习记录、答题数据、笔记内容、课程评价、咨询问题等</li>
                            <li>支付信息：支付账号、银行卡号等（由第三方支付机构处理）</li>
                            <li>反馈信息：通过客服、意见反馈等渠道提供的问题、建议、投诉等</li>
                        </ul>

                        <h4 className="legal-mini-title">（二）我们自动收集的信息</h4>
                        <ul className="legal-list">
                            <li>设备信息：设备型号、操作系统版本、设备识别码、MAC 地址、IP 地址等</li>
                            <li>使用行为信息：登录时间、退出时间、浏览记录、课程观看时长、答题进度、搜索关键词等</li>
                        </ul>

                        <h4 className="legal-mini-title">（三）敏感个人信息</h4>
                        <ul className="legal-list">
                            <li>支付信息（您可能产生的订单信息）</li>
                            <li>个人电话号码</li>
                        </ul>
                        <p className="legal-paragraph">
                            我们仅在获得您明确同意后收集和使用敏感个人信息，并采取额外的安全保护措施。
                        </p>

                        <h3 className="legal-sub-title">四、信息的使用目的</h3>
                        <ul className="legal-list">
                            <li>提供和维护服务：账号管理、课程学习、题库练习、直播互动等</li>
                            <li>优化产品和服务：根据用户行为分析，改进产品功能</li>
                            <li>个性化推荐：基于学习记录和偏好，推荐合适的课程、题库和学习资料</li>
                            <li>安全保障：检测和防范欺诈、恶意攻击等安全风险</li>
                            <li>客户服务：响应咨询、投诉和建议</li>
                            <li>合规要求：遵守法律法规和监管要求</li>
                        </ul>

                        <h3 className="legal-sub-title">五、信息的存储与保护</h3>
                        <ul className="legal-list">
                            <li>存储期限：在实现本政策所述目的的必要范围内保留，账号注销后删除或匿名化</li>
                            <li>存储地点：存储在中国境内，如需跨境传输将按法律法规要求处理</li>
                            <li>安全保护措施：采用加密技术、访问权限控制、安全审计、应急预案等</li>
                        </ul>

                        <h3 className="legal-sub-title">六、信息的共享与披露</h3>
                        <p className="legal-paragraph">
                            我们不会向第三方共享或披露您的个人信息，除非：
                        </p>
                        <ul className="legal-list">
                            <li>经您明确同意或授权</li>
                            <li>为提供服务需要与第三方合作（要求其遵守保密义务）</li>
                            <li>法律法规规定或政府部门要求</li>
                            <li>为保护合法权益、用户利益或公共利益</li>
                        </ul>

                        <h3 className="legal-sub-title">七、您的权利</h3>
                        <ul className="legal-list">
                            <li>查询与访问权：通过 "我的 - 设置 - 个人信息" 查看个人信息</li>
                            <li>更正权：修改个人资料信息（如姓名、邮箱等）</li>
                            <li>删除权：申请删除个人信息（法律法规另有规定的除外）</li>
                            <li>撤回同意权：撤回对敏感个人信息收集和使用的同意</li>
                            <li>账号注销权：通过 "我的 - 设置 - 账号安全 - 注销账号" 申请注销</li>
                            <li>投诉举报权：发现个人信息被泄露或滥用时投诉举报</li>
                        </ul>

                        <h3 className="legal-sub-title">八、Cookie 和同类技术的使用</h3>
                        <p className="legal-paragraph">
                            我们可能使用 Cookie 和同类技术用于保障服务安全、记住登录状态、分析用户行为、提供个性化推荐。您可以通过浏览器或设备设置管理 Cookie，但可能影响部分功能的使用。
                        </p>

                        <h3 className="legal-sub-title">九、未成年人保护</h3>
                        <p className="legal-paragraph">
                            本 APP 主要面向成年人提供服务。如您是未满 18 周岁的未成年人，应在监护人陪同下阅读本政策并获得监护人同意后注册使用。如发现未成年人信息被收集，监护人可联系我们删除。
                        </p>

                        <h3 className="legal-sub-title">十、隐私政策的变更</h3>
                        <p className="legal-paragraph">
                            我们可能根据法律法规变化或业务调整更新本隐私政策，变更后将通过 APP 内弹窗、通知等方式告知您，您继续使用本 APP 服务即视为接受变更后的政策。
                        </p>

                        <h3 className="legal-sub-title">十一、联系我们</h3>
                        <p className="legal-paragraph">
                            如您对本隐私政策有任何疑问、意见或建议，请联系客服人员。
                        </p>
                    </div>

                    <div className="legal-divider"></div>

                    {/* 用户协议部分 */}
                    <div id="agreement" className="legal-section">
                        <h2 className="legal-section-title">上岸消考 APP 用户协议</h2>
                        
                        <h3 className="legal-sub-title">一、协议主体与适用范围</h3>
                        <h4 className="legal-mini-title">（一）协议主体</h4>
                        <p className="legal-paragraph">
                            本协议由信标云（北京）科技有限公司与您签订，您在下载、安装、注册、登录或使用本 APP 服务前，应仔细阅读并理解本协议全部内容。
                        </p>

                        <h4 className="legal-mini-title">（二）适用范围</h4>
                        <p className="legal-paragraph">
                            本协议适用于您通过本 APP 使用的所有服务，包括但不限于账号注册、课程学习、题库练习、模拟考试、直播互动、资料下载、在线咨询等功能。您使用本 APP 服务即视为您已阅读并同意本协议全部条款。
                        </p>

                        <h3 className="legal-sub-title">二、账号注册与管理</h3>
                        <h4 className="legal-mini-title">（一）注册资格</h4>
                        <ul className="legal-list">
                            <li>您应年满 18 周岁，具备完全民事行为能力</li>
                            <li>未满 18 周岁需在监护人陪同下阅读本协议并获得同意</li>
                            <li>应提供真实、准确、完整的注册信息，不得使用虚假信息</li>
                        </ul>

                        <h4 className="legal-mini-title">（二）账号管理</h4>
                        <ul className="legal-list">
                            <li>妥善保管账号和密码，不得转借、出租、出售或共享</li>
                            <li>账号被盗用时立即联系客服</li>
                            <li>对账号下的所有行为和操作承担法律责任</li>
                            <li>可通过 "登录 - 重置密码" 修改密码</li>
                        </ul>

                        <h3 className="legal-sub-title">三、服务内容与使用规则</h3>
                        <h4 className="legal-mini-title">（一）服务内容</h4>
                        <p className="legal-paragraph">
                            本 APP 提供消防工程师考试相关的培训服务，包括课程学习、题库练习、模拟考试、直播互动、资料下载、在线咨询等。我们有权根据业务调整变更服务内容。
                        </p>

                        <h4 className="legal-mini-title">（二）使用规则</h4>
                        <ul className="legal-list">
                            <li>遵守法律法规和公序良俗，不得从事违法违规活动</li>
                            <li>不得侵犯我们或第三方的合法权益</li>
                            <li>不得破坏本 APP 的正常运行（黑客攻击、恶意代码等）</li>
                            <li>不得未经授权复制、传播、修改、出售本 APP 的内容</li>
                            <li>不得发布违法、色情、暴力、侮辱等不良信息</li>
                        </ul>

                        <h3 className="legal-sub-title">四、知识产权</h3>
                        <ul className="legal-list">
                            <li>本 APP 的所有内容均受著作权法、商标法等法律法规保护</li>
                            <li>您仅获得个人、非排他、不可转让的使用权，不得用于商业目的</li>
                            <li>您发布的原创内容知识产权归您所有，但授予我们使用权</li>
                        </ul>

                        <h3 className="legal-sub-title">五、付费服务与退款规则</h3>
                        <h4 className="legal-mini-title">（一）付费服务</h4>
                        <p className="legal-paragraph">
                            部分服务为付费服务，购买前应仔细阅读服务说明和价格信息。支持第三方支付，价格可能调整。
                        </p>

                        <h4 className="legal-mini-title">（二）退款规则</h4>
                        <ul className="legal-list">
                            <li>未开始或未使用的课程可申请退款（7 个工作日内处理）</li>
                            <li>已开始或已使用部分课程按比例退费</li>
                            <li>因我们原因无法提供服务将全额退款</li>
                            <li>因您的原因无法使用服务不予退款</li>
                        </ul>

                        <h3 className="legal-sub-title">六、用户隐私保护</h3>
                        <p className="legal-paragraph">
                            我们尊重并保护您的个人信息，具体规则详见上方的《上岸消考 APP 隐私政策》。
                        </p>

                        <h3 className="legal-sub-title">七、免责声明</h3>
                        <ul className="legal-list">
                            <li>提供的课程、题库等内容仅供参考，不保证考试通过</li>
                            <li>尽力保障服务稳定，但不排除因不可抗力、网络故障等原因导致的问题</li>
                            <li>使用第三方服务时应遵守其条款，我们不承担第三方服务的责任</li>
                        </ul>

                        <h3 className="legal-sub-title">八、违约责任</h3>
                        <ul className="legal-list">
                            <li>违反本协议可能面临警告、限制功能、暂停账号、注销账号等措施</li>
                            <li>造成损失应承担赔偿责任</li>
                            <li>我们违约也应承担相应责任</li>
                        </ul>

                        <h3 className="legal-sub-title">九、协议变更与终止</h3>
                        <ul className="legal-list">
                            <li>可能根据法律法规变化或业务调整更新本协议</li>
                            <li>可通过注销账号终止本协议，或我们有权因违规终止协议</li>
                            <li>停止运营时将提前 30 天通知并妥善处理用户数据</li>
                        </ul>

                        <h3 className="legal-sub-title">十、争议解决</h3>
                        <p className="legal-paragraph">
                            本协议适用中华人民共和国法律。争议首先通过友好协商解决；协商不成的，向公司所在地有管辖权的人民法院提起诉讼。
                        </p>

                        <h3 className="legal-sub-title">十一、其他条款</h3>
                        <ul className="legal-list">
                            <li>本协议自使用本 APP 服务之日起生效</li>
                            <li>未尽事宜依照《上岸消考 APP 隐私政策》及相关法律法规执行</li>
                            <li>协议条款与法律法规相冲突时以法律法规为准</li>
                        </ul>

                        <p className="legal-company-info">
                            信标云（北京）科技有限公司<br/>
                            2026 年 5 月 3 日
                        </p>
                    </div>
                </div>
            </div>

            {/* 底部 */}
            <footer className="footer">
                <p>© 2026 上岸消考 版权所有 | 专注中级消防设施操作员考试上岸</p>
            </footer>
        </div>
    );
}

export default LegalPages;
